import { Component, OnInit } from '@angular/core';
import { RouterOutlet, Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';
import { PriceListService } from './service/price-list.service';
import { CacheService } from './service/cache.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  providers: [PriceListService, CacheService]
})
export class AppComponent implements OnInit {
  public showWhatsApp: boolean = false;

  private readonly VISIBLE_ROUTES = ['login', 'inicio'];

  constructor(
    private router: Router,
    private servicePriceList: PriceListService,
    private serviceCache: CacheService,
  ) {}

  ngOnInit(): void {
    // Subscribe primero, asi capturamos cualquier NavigationEnd futuro.
    // urlAfterRedirects toma la URL final despues de resolver redirects
    // (ej: '' -> 'main' -> 'main/inicio').
    this.router.events
      .pipe(filter((e): e is NavigationEnd => e instanceof NavigationEnd))
      .subscribe(e => this.updateWhatsAppVisibility(e.urlAfterRedirects));

    // Cubre el caso en que el ngOnInit corre DESPUES del primer
    // NavigationEnd (si el initialNavigation ya termino). Diferido para
    // que ocurra despues de la primera navegacion — sino router.url
    // puede ser '/' antes del redirect y showWhatsApp queda en false.
    Promise.resolve().then(() => this.updateWhatsAppVisibility(this.router.url));

    // Cargar la lista de precios (incluye la LISTA WEB) al iniciar la app,
    // asi getDiscount() en config.ts puede aplicar el descuento correcto para
    // anonimos y clientes finales. No requiere login.
    this.servicePriceList.getAllWithoutParams().subscribe((res: any) => {
      if (res != null) {
        this.serviceCache.setPriceList(res);
      }
    });
  }

  private updateWhatsAppVisibility(url: string): void {
    this.showWhatsApp = this.VISIBLE_ROUTES.some(route => url.includes(route));
  }

  goToWhatsAppTaller(): void {
    window.open('https://api.whatsapp.com/send/?phone=543513772531&text=%C2%A1Hola+Bonafe!+tengo+una+consulta+sobre+taller/reparaciones...&type=phone_number&app_absent=0', '_blank');
  }

  goToWhatsAppRepuestos(): void {
    window.open('https://api.whatsapp.com/send/?phone=543513129614&text=%C2%A1Hola+Bonafe!+tengo+una+consulta+sobre+repuestos...&type=phone_number&app_absent=0', '_blank');
  }
}
